import React, { FC } from 'react';
import { globalConfig } from 'configs/globalConfig';

const CurrentFooter = React.lazy(() => import('./CommonFooter/CommonFooter'));

const Footer: FC<unknown> = () => {
    return (
        <React.Suspense fallback={<></>}>
            <CurrentFooter isLoggedIn={globalConfig.isLoggedIn || false} />
        </React.Suspense>
    );
};

export default Footer;
